var modalIds = {
    UNENROLL_MODAL_ID: "unenroll-modal",
    UNENROLL_SUCCESS_MODAL_ID: "unenroll-success-modal",
    CROSS_BORDER_MODAL_ID: "cross-border-modal",
    QUESTIONS_ABOUT_CREDIT_SCORE_MODAL_ID: "credit-questions-modal",
    TOOLTIP_MODAL_ID: "tooltip-modal",
};
export default modalIds;
